import React from 'react';
import { Application } from '../../../models';
import ESignaturaForm from './ESignatureForm';

interface TenthStepProps {
  application?: Application;
  isReadOnly?: boolean;
}

export default function TenthStep({
  application = null,
  isReadOnly = false,
}: TenthStepProps) {
  return (
    <div className="p-6 lg:py-20 lg:px-32 flex flex-col">
      <div className="mt-8">
        <h2 className="font-bold text-5xl text-neutral-600">
          Applicant's E-Signature
        </h2>
      </div>
      <div className="mt-8 w-full">
        <p className="mb-2 text-lg lg:text-2xl text-neutral-500">
          By signing (typing your legal name) in the space below, you are
          certifying that all information is correct and that you are the person
          completing the application.
        </p>
        <p className="mb-8 text-lg lg:text-2xl text-neutral-500">
          When you press the submit button, you will receive an email
          confirmation that your application was received. Please print for your
          records and retain as verification for your application.
        </p>
        <ESignaturaForm application={application} isReadOnly={isReadOnly} />
      </div>
    </div>
  );
}
